<template>
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Passkeys</h3>
    </div>
    <div class="card-body p2">
      <p class="text-muted">
        Sign in with your fingerprint, face or device PIN instead of your
        password and two factor code.
      </p>
      <div v-if="!supported" class="alert alert-warning">
        This browser does not support passkeys.
      </div>
      <div class="list-group mb-3" v-if="Passkeys.length">
        <div
          class="list-group-item d-flex align-items-center"
          v-for="passkey of Passkeys"
          :key="passkey.ID"
        >
          <div class="flex-fill">
            <div>{{ passkey.Name }}</div>
            <div class="text-muted small">{{ usage(passkey) }}</div>
          </div>
          <button
            class="btn btn-outline-danger"
            type="button"
            @click="remove(passkey)"
          >
            Remove
          </button>
        </div>
      </div>
      <button
        class="btn btn-outline-success"
        style="width: 100%"
        type="button"
        :disabled="!supported"
        @click="add()"
      >
        Add a passkey
      </button>
    </div>
  </div>
</template>
<script>
import { browserSupportsWebAuthn } from '@simplewebauthn/browser'
import moment from 'moment'
import { getPasskeys, registerPasskey, removePasskey } from '@/api/passkeys'

export default {
	data () {
		return {
			Passkeys: [],
			supported: browserSupportsWebAuthn()
		}
	},
	methods: {
		usage (passkey) {
			const added = 'Added ' + moment(passkey.CreatedAt).calendar()
			if (!passkey.LastUsedAt) {
				return added + ', never used'
			}
			return added + ', last used ' + moment(passkey.LastUsedAt).calendar()
		},
		async confirmPassword (title) {
			const result = await this.$swal.fire({
				titleText: title,
				input: 'password',
				inputLabel: 'Confirm your password to continue',
				inputAttributes: { autocomplete: 'current-password' },
				showCancelButton: true,
				confirmButtonText: 'Confirm'
			})
			return result.isConfirmed && result.value ? result.value : null
		},
		async add () {
			const nameResult = await this.$swal.fire({
				title: 'Add a passkey',
				input: 'text',
				inputLabel: 'Name it after the device or password manager',
				inputPlaceholder: 'MacBook, iPhone, YubiKey...',
				inputAttributes: { maxlength: 64 },
				showCancelButton: true,
				confirmButtonText: 'Continue',
				inputValidator: (value) => !value.trim() && 'Enter a name'
			})
			if (!nameResult.isConfirmed) {
				return
			}
			const password = await this.confirmPassword('Add a passkey')
			if (!password) {
				return
			}
			registerPasskey(password, nameResult.value)
				.then((data) => {
					if (data.Status === 'ok') {
						this.fetchPasskeys()
					}
				})
				.catch((err) => {
					if (err?.name === 'NotAllowedError' || err?.name === 'AbortError') {
						return
					}
					let text = err?.response?.data?.Data || err?.message
					if (err?.name === 'InvalidStateError') {
						text = 'This device already has a passkey for your account.'
					}
					this.$swal.fire({ icon: 'error', text })
				})
		},
		async remove (passkey) {
			const password = await this.confirmPassword('Remove passkey "' + passkey.Name + '"?')
			if (!password) {
				return
			}
			removePasskey(passkey.ID, password)
				.then((data) => {
					if (data.Status === 'ok') {
						this.fetchPasskeys()
					}
				})
				.catch((err) => {
					this.$swal.fire({
						icon: 'error',
						text: err?.response?.data?.Data || err?.message
					})
				})
		},
		fetchPasskeys () {
			getPasskeys()
				.then((data) => {
					if (data.Status === 'ok') {
						this.Passkeys = data.Data
					}
				})
				.catch((err) => {
					this.$swal.fire({
						icon: 'error',
						text: err?.response?.data?.Data || err?.message
					})
				})
		}
	},
	mounted () {
		this.fetchPasskeys()
	}
}
</script>
